import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-detail-sidebar-layout',
  templateUrl: './detail-sidebar-layout.component.html',
  styleUrl: './detail-sidebar-layout.component.scss',
  standalone: false,
})
export class DetailSidebarLayoutComponent implements OnInit {
  title: string = '';
  items: any[] = [];
  constructor(private cdr: ChangeDetectorRef, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.items = data['sidebarItems'] || [];
      this.title = data['sidebarTitle'] || '';
      this.cdr.detectChanges();
    });
  }
}
